export default __webpack_public_path__ + "static/medium-17c94287bac3f1cf030beef8096235a2.woff2";